import React, { useState } from 'react';
import './header.scss';
import Navbar from '../../components/Navbar/navbar';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false); // close menu after clicking a link
    }
  };

  return (
    <div className='heads'>
      <Navbar />  
      <div className="header">  
            <div className="header__text">
              <h1>Talk Freely. Connect Anonymously. <br/>Learn Without Judgment.</h1>
              <p>Join Orter today and experience authentic, judgment-free conversations.</p>
              <button onClick={() => scrollToSection('about')}className="header__btn">Let’s Start</button>
            </div>
            <div className="header__image">
              <img src='https://images.pexels.com/photos/27413499/pexels-photo-27413499.jpeg' alt="Woman smiling at desk" />
            </div>
          </div>
        </div>
  );
};

export default Header;